/* eslint-disable no-useless-escape */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import "./add-content.scss";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { ProgressBar } from 'react-bootstrap';
import {
  addLink,
  googleLinkPreview,
  handleChangeSource,
  uploadVideo,
  uploadDocument,
  resetPercentage,
  updateContent,
  addQuizToPod
} from "../../../../ActionCreators/AdminAction/manageSkillpathAction";
import { clearErrors } from "../../../../ActionCreators/errorAction";
import Snackbar from '@mui/material/Snackbar';
import PreviewLink from "./previewLink";
import $ from 'jquery';
import QuizList from "./quizList";


class AddResource extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      checked: false,
      isAddTopic: false,
      source: '',
      id: 1,
      videoTitle: "",
      description: "",
      addVideo: false,
      // link: false,
      video: "",
      file: true,
      videoUrl: "/images/empty-image.svg",
      image: "",
      successMsg: false,
      imageUrl: "/images/empty-image.svg",
      chars_left: 50,
      maxChar: 50,
      max_desc_char: 250,
      desc_char_left: 250,
      update: false,
      to: '',
      from: '',
      recommended: false,
      subjectSelect: '',
      selectType: '',
      url_type: '',
      topicsId: '',
      subjectId: '',
      subjects: '',
      topic: '',
      contentTagsTitle: [],
      from1: '00',
      from2: '00',
      to1: '00',
      to2: '00',
      resourceObj: '',
      link: true
    };
  }

  componentDidMount = async () => {
    await this.props.resetPercentage();
    this.setState({
      topic: this.props.history.location.state.topic,
      subtopic: this.props.history.location.state.subtopic,
      topicId: this.props.history.location.state.topicId,
      skillId: this.props.history.location.state.skillId,
      skillPathId: this.props.history.location.state.skillPathId,
      link: this.props.history.location.state.type === 'Video' ? true : false,
      file: this.props.history.location.state.type === 'Document' ? true : false
    })
    const { details, edit, type } = this.props.history.location.state;
    // this.props.getSubjectList(false);

    if (type === 'quiz' && edit) {
      this.setState({
        isQuizAddShow: true,
        quizTitle: details.title,
        id: details._id,
        selectType: this.props.quiz_type,
        isShowList: true
      })
    }
    // else if (type === 'Question' && edit) {
    // }
    if (details !== undefined && edit) {
      if (details.url_type && details.url_type === 'file' && details.type === 'Video') {
        this.setState({
          file: true,
          link: false,
        })
      }
      else if (details.url_type && details.url_type === 'link' && details.type === 'Video') {
        this.setState({
          file: false,
          link: true,
        }, () => {
          this.props.googleLinkPreview(details.url);
        })
      }
      details !== undefined && edit && this.setState({
        id: details._id,
        videoTitle: details.title,
        videoName: details.url,
        video: details.url,
        imageUrl: details.image,
        description: details.description,
        image: details.image,
        url_type: details.url_type && details.url_type,
        to: !details?.duration.includes('-') ? '00:00' : (details.duration !== undefined && details.duration !== null && details?.duration?.split('-')[1]),
        from: !details?.duration.includes('-') ? '00:00' : (details.duration !== undefined && details.duration !== null && details?.duration?.split('-')[0]),
        from1: (details.duration !== undefined && details.duration !== null) ? (!details?.duration.includes('-') ? '00' : details?.duration.split('-')[0].split(':')[0]) : '00',
        from2: (details.duration !== undefined && details.duration !== null) ? (!details?.duration.includes('-') ? '00' : details.duration.split('-')[0].split(':')[1]) : '00',
        to1: (details.duration !== undefined && details.duration !== null) ? (!details?.duration.includes('-') ? '00' : details.duration.split('-')[1].split(':')[0]) : '00',
        to2: (details.duration !== undefined && details.duration !== null) ? (!details?.duration.includes('-') ? '00' : details.duration.split('-')[1].split(':')[1]) : '00',
        chars_left: this.state.maxChar - details.title.length,
      })
    }
  }

  handleShow = () => {
    this.setState({
      isQuizAddShow: true,
      selectType: '',
      subjectSelect: '',
      isShowList: false
    });
  };

  backtoBubble = () => {
    this.props.history.goBack();
    // this.props.showSideBar();
  };

  snackClosed = () => {
    this.props.clearErrors();
    this.setState({
      successMsg: false,
      successMessageText: ''
    })
  };

  closePopover = () => {
    this.setState({
      show: false,
    });
  };

  componentWillUnmount = () => {
    // this.props.deleteQuizQuestions();
  };

  backToSubject = () => {
    this.props.history.goBack();
    this.props.history.goBack();
    this.props.history.goBack();
  };

  backToTopic = () => {
    this.props.history.goBack();
    this.props.history.goBack();
  };

  onvideoTitleChange = (val) => {
    const charCount = val.length;
    const maxChar = this.state.maxChar;
    const charLength = maxChar - charCount;
    this.setState({
      videoTitle: val,
      videoTitleError: "",
      chars_left: charLength,
    });
  };

  onvideodescriptionChange = (val) => {
    const charCount = val.length;
    const maxChar = this.state.max_desc_char;
    const charLength = maxChar - charCount;
    this.setState({
      description: val,
      descriptionError: "",
      desc_char_left: charLength,
    });
  };

  changeVideo = (e) => {
    var Extension = e.target.value
      .substring(e.target.value.lastIndexOf(".") + 1)
      .toLowerCase();

    if (this.props.history.location.state.type === "Video" && (Extension === "mkv" || Extension === "avi" || Extension === "mp4")) {
      const file = e.target.files[0];
      const reader = new FileReader();
      if (file) {
        reader.readAsDataURL(file);
        this.setState({
          update: true,
          videoUrl: reader.result,
          videoName: file.name,
          video: file,
          addVideoError: "",
        });
      } else {
        this.setState({
          imageUrl: "",
          videoName: "",
          update: false
        });
      }
    }
    else if (this.props.history.location.state.type === "Document" && (Extension === "png" || Extension === "jpeg" || Extension === "jpg" || Extension === "pdf")) {
      const file = e.target.files[0];
      const reader = new FileReader();

      if (file) {
        reader.readAsDataURL(file);
        this.setState({
          update: true,
          videoUrl: reader.result,
          videoName: file.name,
          video: file,
          addVideoError: "",
        });
      } else {
        this.setState({
          update: false,
          imageUrl: "",
          videoName: "",
        });
      }
    } else {
      this.setState({
        successMsg: true,
        successMessageText: "The file Format not allow",
      });
    }
  };

  onSourceChange = (val) => {
    this.setState({
      source: val,
      sourceError: ''
    })
  }



  saveVideoOrDocument = async () => {
    this.props.resetPercentage();
    if (this.props.previewData) {
      const { previewData, articleSource } = this.props
      var obj = {
        _id: this.state.skillPathId,
        topic_id: this.state.topicId,
        subtopic: this.state.subtopic,
        description: previewData?.description,
        title: previewData?.title,
        image: previewData?.image || this.state.image,
        type: this.props.history.location.state.type,
        url: previewData?.url,
        source: articleSource,
        url_type: 'link',
        from: this.state.from,
        to: this.state.to
      }
      await this.props.addLink(obj);
      if (this.props.successEnable) {
        await this.backtoBubble();
      }

    }
    else {
      if (this.state.videoTitle.trim() === "" || null) {
        this.setState({
          videoTitleError: "Title cannot empty",
        });
      }
      else if (this.state.description.trim() === "" || null) {
        this.setState({
          descriptionError: "description cannot empty",
        });
      }
      else if (this.state.video === '') {
        this.setState({
          addVideoError: this.props.history.location.state.type === 'Video' ? "Please upload video" : "Please upload document",
        });
      }
      else if (this.state.source.trim() === "" || null) {
        this.setState({
          sourceError: "source cannot empty",
        });
      }

      else {
        this.setState({
          videoTitleError: "",
          descriptionError: "",
          addVideoError: "",
          sourceError: ''
        });
        if (this.props.history.location.state.type === 'Video') {
          const obj = new FormData();
          obj.append('_id', this.state.skillPathId);
          obj.append("topic_id", this.state.topicId);
          obj.append("subtopic", this.state.subtopic);
          obj.append("description", this.state.description);
          obj.append("image", this.state.image);
          this.state.from !== '' && obj.append("to", this.state.to);
          obj.append("from", this.state.from)
          obj.append("title", this.state.videoTitle);
          obj.append("video", this.state.video);
          obj.append("source", this.state.source);
          obj.append("skill_id", this.state.skillId);
          obj.append('url_type', 'file')
          await this.props.uploadVideo(obj);
          if (this.props.successEnable) {
            !this.props.documentDataState && await this.backtoBubble();
          }
        }
        else {
          var data1 = new FormData();
          data1.append('_id', this.state.skillPathId);
          data1.append("topic_id", this.state.topicId);
          data1.append("subtopic", this.state.subtopic);
          data1.append("description", this.state.description);
          data1.append("image", this.state.image);
          data1.append("title", this.state.videoTitle);
          data1.append("document", this.state.video);
          data1.append("source", this.state.source);
          data1.append("skill_id", this.state.skillId);
          data1.append('url_type', 'file')
          // data1.append('from', this.state.from)
          // this.state.from !== '' && data1.append('to', this.state.to)
          // data1.append('recommended', this.state.recommended)
          await this.props.uploadDocument(data1);
          if (this.props.successEnable) {
            !this.props.documentDataState && await this.backtoBubble();
          }
        }
      }
    }
  };
  backToMain = () => {
    if (window.location.pathname.split('/')[1] === 'manage-content') {
      this.setState({ isQuestionVisible: false, questionListForQuiz: true });
    }
    else {
      this.props.history.push('/my-content')
    }
  };

  backToList = () => {
    this.setState({ isquestionListVisble: false });
  };

  changeImage = (e) => {
    var Extension = e.target.value
      .substring(e.target.value.lastIndexOf(".") + 1)
      .toLowerCase();
    if (e.target.files[0].size > 2097152) {
      this.setState({
        successMsg: true,
        successMessageText: "The file size cannot exceed 2MB",
      });
    }
    if (
      Extension === "png" ||
      Extension === "jpeg" ||
      Extension === "jpg" ||
      Extension === "mp4"
    ) {
      const file = this.refs.uploadImg.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        this.setState({
          imageUrl: reader.result,
          imageError: "",
        });
      };
      if (file) {
        reader.readAsDataURL(file);
        this.setState({
          imageUrl: reader.result,
          imageName: file.name,
          image: file,
        });
      } else {
        this.setState({
          imageUrl: "",
          imageName: "",
        });
      }
    } else {
      this.setState({
        successMsg: true,
        successMessageText: "File Format not allowed",
      });
    }
  };

  onChangetitle = (val) => {
    this.setState({
      quizTitle: val,
      titleError: "",
    });
  };





  onFileChanged = (e) => {
    this.setState({
      file: e.currentTarget.checked,
      link: false
    });
  };

  onLinkChanged = (e) => {
    this.setState({
      link: e.currentTarget.checked,
      file: false
    });
  };


  handleChangeVideoLink = async (evt) => {
    var regex =
      /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    if (!regex.test(evt.target.value)) {
      this.setState({ videoTitleError: "please enter link" });
      this.props.googleLinkPreiviewSetNull();
      return false;
    } else {
      this.props.googleLinkPreview(evt.target.value);
      this.setState({ videoTitleError: "", video: evt.target.value });
    }
  };

  handleDragEnd = async (result) => {
    if (!result.destination) return
    await this.props.reorederSubTopicsProps(result)
  }

  editResource = async () => {
    if (this.props.previewData && this.state.link) {
      if (this.props.history.location.state.type === 'Video') {
        const { previewData } = this.props
        var data = new FormData();
        data.append("topic_id", this.state.topicId);
        data.append("_id", this.state.id);
        data.append("description", previewData.description);
        data.append("image", previewData.image || this.state.image);
        data.append("title", previewData.title);
        data.append("type", this.props.history.location.state.type);
        data.append("url", previewData.url);
        data.append('to', this.state.to)
        data.append('from', this.state.from)
        // data.append('recommended', this.state.recommended)
        await this.props.updateContent(data)
        await this.backtoBubble();
      }
      else {
        const { previewData } = this.props
        data.append("topic_id", this.state.topicId);
        data.append("_id", this.state.id);
        data.append("description", previewData.description);
        data.append("image", previewData.image || this.state.image);
        data.append("title", previewData.title);
        data.append("type", this.props.history.location.state.type);
        data.append("url", previewData.url);
        await this.props.updateVideoorDocuments(data)
        await this.backtoBubble();
      }
    }
    else {
      if (this.state.videoTitle.trim() === "" || null) {
        this.setState({
          videoTitleError: "Title cannot empty",
        });
      } else if (this.state.description === "" || null) {
        this.setState({
          descriptionError: "description cannot empty",
        });
      }
      else if (this.state.video === '') {
        this.setState({
          addVideoError: this.props.history.location.state.type === 'Video' ? "Please upload video" : "Please upload document",
        });
      }
      else {
        this.setState({
          videoTitleError: "",
          descriptionError: "",
          addVideoError: "",
        });
        if (this.props.history.location.state.type === 'Video') {
          var obj = new FormData();
          obj.append("topic_id", this.state.topicId);
          obj.append("_id", this.state.id);
          obj.append("description", this.state.description);
          obj.append("image", this.state.image);
          obj.append("title", this.state.videoTitle);
          (this.state.update ?
            obj.append("video", this.state.video) :
            obj.append('url', this.state.video))
          this.state.from !== '' && obj.append('to', this.state.to)
          obj.append('from', this.state.from)
          obj.append('type', this.props.history.location.state.type)
          // obj.append('recommended', this.state.recommended)
          await this.props.updateContent(obj);
          !this.props.documentDataState && await this.backtoBubble()

        }
        else {
          var data2 = new FormData();
          data2.append("topic_id", this.state.topicId);
          data2.append("_id", this.state.id);
          data2.append("description", this.state.description);
          data2.append("image", this.state.image);
          data2.append("title", this.state.videoTitle);
          (this.state.update ?
            data2.append("document", this.state.video) :
            data2.append('url', this.state.video))
          data2.append('type', this.props.history.location.state.type)
          // data2.append('recommended', this.state.recommended)
          await this.props.updateContent(data2);
          !this.props.documentDataState && await this.backtoBubble()


        }

      }
    }

  }

  goToSubTopicsContent = (topicId, topic, subtopic) => {
    this.setState({
      topicId, topic, subtopic
    })
  }

  getFromTime1 = (val) => {
    this.setState({
      from1: val,
      toError: ""
    }, () => {
      this.setState({
        from: (this.state.from1 || '00') + ':' + (this.state.from2 || '00'),
      })
    })
  }

  getFromTime2 = (val) => {
    this.setState({
      from2: val,
      from: this.state.from1 + ':' + val,
      toError: ""
    }, () => {
      var regExp = /(\d{1,2})\:(\d{1,2})/;
      if (parseInt(this.state.to.replace(regExp, "$1$2$3")) < parseInt(this.state.from.replace(regExp, "$1$2$3"))) {
        this.setState({
          toError: 'Please select correct time',
          to1: '',
          to2: ''
        })
      }
      else {
        this.setState({
          toError: ''
        })
      }
    })
  }

  getToTime1 = (val) => {
    this.setState({
      to1: val,
      toError: ""
    }, () => {
      this.setState({
        to: this.state.to1 + ':' + (this.state.to2 || '00'),
      })
    })
  }
  getToTime2 = (val) => {
    this.setState({
      to2: val,
      to: this.state.to1 + ':' + val,
      toError: ""
    }, () => {
      var regExp = /(\d{1,2})\:(\d{1,2})/;
      if (parseInt(this.state.to.replace(regExp, "$1$2$3")) < parseInt(this.state.from.replace(regExp, "$1$2$3"))) {
        this.setState({
          toError: 'Please select correct time',
          to1: '',
          to2: ''
        })
      }
      else {
        this.setState({
          to: this.state.to1 + ':' + this.state.to2,
          toError: ''
        })
      }
    })

  }

  handleChecked = (e) => {
    this.setState({
      recommended: e.target.checked
    })
  }

  handlePartial = (e) => {
    if (e.target.checked) {
      this.setState({
        partial: e.target.checked
      })
    }
    else {
      this.setState({
        partial: e.target.checked,
        to: '',
        from: ''
      })
    }

  }

  onChangeSubject = (val) => {
    this.setState({ subject: val, subjectError: "", subjectSelect: val });
  };

  onChangeType = (val) => {
    this.setState({ selectType: val, typeError: "", });
  }



  openView = (el) => {
    this.setState({
      isView: true,
      resource: el
    })
    $("body").css("overflow", "hidden");
  }

  closeDetails = () => {
    this.setState({
      isView: false,
      resource: ""
    })
    $("body").css("overflow", "visible");
  }

  resourceData = (el, title) => {
    let obj = {
      _id: el._id,
      type: this.props.history.location.state.type,
      topic_id: this.state.topicId,
      subtopic: this.state.subtopic
    }
    this.setState({
      resourceObj: obj
    })
  }

  saveResourceList = async () => {
    await this.props.addToResource(this.state.resourceObj);
    await this.backtoBubble();
    await this.setState({
      resourceObj: '',
      added: false,
      link: false,
    });
  }

  saveQuizByID = async (id) => {
    const obj = {
      pod_id: this.state.topicId,
      quiz_id: id,
      subtopic: this.state.subtopic
    }
    await this.props.addQuizToPod(obj);
    await this.backtoBubble();
  }

  render() {
    var times = [];
    var min = null;

    for (min = 0; min < 60; min++) {
      times.push(min < 10 ? ('0' + min) : min)
    }

    // const subject = { label: this.props.history.location.state.subject, value: this.props.subject_id }
    const { type, edit } = this.props.history.location.state;
    const { previewData, documentDataState, percent, theme, successEnable, successMessage, successMessageText } = this.props
    return (
      <Fragment>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
          open={successMessage}
          onClose={() => this.snackClosed()}
          message={successMessageText}
          autoHideDuration={4000}
        />
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
          open={successEnable}
          onClose={() => this.snackClosed()}
          message={successMessageText}
          autoHideDuration={4000}
        />
        {
          (documentDataState) ?
            <div className='div-overlay'>
              {
                type === 'Video' ?
                  <div className='progress-upload'>
                    <p>Please wait uploading video... </p>
                    <ProgressBar striped variant='success' now={percent} active label={`${percent}%`} />
                  </div>
                  :
                  <div className='progress-upload'>
                    <p>Please wait uploading document... </p>
                    <ProgressBar striped variant='success' now={percent} active label={`${percent}%`} />
                  </div>
              }
            </div>
            : null
        }
        <div className="subtopics-module">
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
            open={successEnable}
            onClose={() => this.props.clearErrors()}
            message={successMessageText}
            autoHideDuration={4000}
          />
          <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
            open={this.state.successMsg}
            onClose={() => this.snackClosed()}
            message={this.state.successMessageText}
            autoHideDuration={4000}
          />

          {type === "quiz" ? (
            < QuizList
              backToMain={() => this.backToMain()}
              isQuiz={this.handleShow}
              quizData={this.saveQuizByID}
              skillId={this.props.history.location.state.skillId}
              skill={this.props.history.location.state.skill}
            />

          ) : (type === 'Question' && window.location.pathname.split('/')[1] === 'my-content') ? null
            // <AddQuestions
            //   type={"Question Bank"}
            //   backToMain={this.backToMain}
            //   successEnable={this.props.successEnable}
            //   successMessageText={this.props.successMessageText}
            //   snackClosed={this.snackClosed}
            //   questions={this.props.editQuestionData}
            //   edit={this.props.history.location.state.edit}
            //   editContentQuestion={this.props.editContentQuestion}
            //   isAddfromQuiz={true}
            //   resetPercentage={this.props.resetPercentage}
            //   savedContentQuestion={this.props.savedContentQuestion}
            //   getTopicsOfSub={this.props.getTopicsOfSub}
            //   subjectTopicList={this.props.subjectTopicList}
            //   subjectForSelect={this.props.subjectForSelect}
            //   getSubTopics={this.props.getSubTopics}
            //   subTopicsContent={this.props.subTopicsContent}
            //   getClubbedQuestionList={this.props.getClubbedQuestionList}
            // />
            :
            (
              <div className={type === "Video" || type === "Document" ? "manage-subtopics subtopic-video" : "manage-subtopics"} style={{ width: "85%", marginLeft: -45 }}>
                <div style={{ padding: 18, paddingLeft: 39 }}>
                  <div className="d-flex" style={{ fontSize: 20, cursor: "pointer" }}>
                    <p style={{ marginTop: 5 }} onClick={() => this.backtoBubble()}>
                      <img
                        src="/images/back.svg"
                        alt=""
                        width="20px"
                        className="mr-4"
                      />
                    </p>
                    <div className="bc-nav">
                      <h1>{type === "Video" && !edit ? "Add Video" : type === 'Video' && edit ? 'Edit Video' : type === 'Document' && !edit ? "Add Document" : type === 'Document' && edit ? 'Edit Document' : null}</h1>
                    </div>
                  </div>
                  <div className="order-table-header">
                    <div className="subject-header">
                      <div div className="add-subject mt-1">
                        <p className='mt-0'>Fields marked * are mandatory</p>
                        <div className="mt-2 custom-radio-button">
                          {/* <label>
                            {type === "Video" ? "Video Source*" : "Document Source*"}
                          </label> */}
                          {/* <div className="duration d-flex mt-2">
                            <label style={{ width: "13%", display: 'flex' }}>
                              <input
                                onChange={this.onFileChanged}
                                type="radio"
                                className="mr-2"
                                value={this.state.file}
                                name="radio1"
                                checked={this.state.file}
                                disabled={edit ? this.state.file ? false : true : false}
                              />
                              File
                            </label>
                            {
                              type === 'Video' ?
                                <label style={{ width: "13%", display: 'flex' }}>
                                  <input
                                    type="radio"
                                    className="mr-2"
                                    name="radio1"
                                    value={this.state.link}
                                    onChange={this.onLinkChanged}
                                    checked={this.state.link}
                                    disabled={edit ? this.state.link ? false : true : false}

                                  />
                                  Link
                                </label>
                                : null
                            }


                          </div> */}
                        </div>
                        {this.state.link ? (
                          <>
                            <div className="form-group mt-3">
                              <label>
                                {type === "Video" ? "Video Link*" : "Document Link"}
                                <aside className="float-right">
                                  {/* {this.state.chars_left} */}
                                </aside>
                              </label>
                              <input
                                className="form-control mt-2"
                                style={{ width: "52%" }}
                                // maxLength={this.state.maxChar}
                                value={this.state.video}
                                onChange={(e) => this.handleChangeVideoLink(e)}
                              />
                              <small>{this.state.videoTitleError}</small>
                            </div>
                            {previewData ? (
                              <div style={{ width: "52%" }}>
                                <PreviewLink previewData={previewData} />
                              </div>
                            ) : null}
                            <div className="mt-2">
                              <label>Source*</label>
                              <input
                                className="form-control mt-2"
                                value={this.props.articleSource}
                                onChange={(e) => this.props.handleChangeSource(e.target.value)}
                              />
                            </div>
                          </>
                        ) :
                          this.state.file ?
                            (
                              <>
                                <div className="form-group mt-3">
                                  <label>
                                    {type === "Video" ? "Video Title*" : "Document Title*"}
                                    <aside className="float-right">
                                      {this.state.chars_left}
                                    </aside>
                                  </label>
                                  <input
                                    className="form-control mt-2"
                                    style={{ width: "52%" }}
                                    maxLength={this.state.maxChar}
                                    value={this.state.videoTitle}
                                    onChange={(e) =>
                                      this.onvideoTitleChange(e.target.value)
                                    }
                                  />
                                  <small>{this.state.videoTitleError}</small>
                                </div>
                                <div className="form-group mt-4">
                                  <label>
                                    Description*
                                    <aside className="float-right">
                                      {this.state.desc_char_left}
                                    </aside>
                                  </label>
                                  <textarea
                                    className="form-control mt-2"
                                    maxLength={this.state.max_desc_char}
                                    value={this.state.description}
                                    onChange={(e) =>
                                      this.onvideodescriptionChange(e.target.value)
                                    }
                                  />
                                  <small>{this.state.descriptionError}</small>
                                </div>
                                <div className="mt-4">
                                  <label>
                                    {" "}
                                    {type === "Video" ? "Video File*" : "Document File*"}
                                  </label>
                                  {type === "Video" ? null : (
                                    <p>Only PDF accepted</p>
                                  )}
                                  <div className="d-flex align-items-center ">
                                    <div className="d-flex flex-column mt-3 position-relative ">
                                      {/* <span><img src='/images/gallery-icon.svg' width='24px' alt='' /> &nbsp;Select From Gallery</span> */}
                                      <span>
                                        <img src="/images/upload-icon.svg" alt="" />{" "}
                                        &nbsp;Upload file from computer &nbsp;
                                        <small>{this.state.videoName}</small>
                                        <input
                                          type="file"
                                          ref="uploadImg"
                                          className="file-upload_question"
                                          name="selectedFile"
                                          accept={
                                            type === "Video"
                                              ? "video/*"
                                              : ".pdf,.doc"
                                          }
                                          onChange={this.changeVideo}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                  <small>{this.state.addVideoError}</small>
                                  <small>{this.state.imageError}</small>
                                  {/* {this.props.documentDataState ? (
                              <small>Please wait uploading document</small>
                            ) : null} */}
                                </div>

                                <div className="mt-2">
                                  <label>Source*</label>
                                  <input
                                    className="form-control mt-2"
                                    value={this.state.source}
                                    onChange={(e) => this.onSourceChange(e.target.value)}
                                  />
                                </div>
                                <small>{this.state.sourceError}</small>
                                <div className="mt-3">
                                  <label>Resource Cover Image</label>
                                  <div className="d-flex align-items-center ">
                                    {this.state.image ? (
                                      <div className="program-image">
                                        <img
                                          src={this.state.imageUrl}
                                          alt=""
                                          width="139px"
                                          height="78px"
                                        />
                                      </div>
                                    ) : (
                                      <div className="program-image">
                                        <img src={this.state.imageUrl} alt="" />
                                      </div>
                                    )}

                                    <div className="d-flex flex-column mt-3 position-relative upload-img">
                                      {/* <span>
                              <img
                                src="/images/gallery-icon.svg"
                                width="24px"
                                alt=""
                              />{" "}
                              &nbsp;Select From Gallery
                            </span> */}
                                      <span>
                                        {" "}
                                        <img src="/images/upload-icon.svg" alt="" />{" "}
                                        &nbsp;Upload Image &nbsp;{" "}
                                        <small>{this.state.imageName}</small>
                                        <input
                                          type="file"
                                          ref="uploadImg"
                                          className="file-upload"
                                          style={{ left: 0 }}
                                          name="selectedFile"
                                          accept="image/png, image/jpeg,.pdf,.doc"
                                          onChange={this.changeImage}
                                        />
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )
                            :
                            null
                        }
                        {/* {
                          this.state.file ?
                            <div className="form-group mt-3">
                              <label>
                                Source*
                              </label>
                              <input
                                className="form-control mt-2"
                                // style={{ width: "50%" }}
                                value={this.state.source}
                                onChange={(e) =>
                                  this.onVideoSourceChange(e.target.value)
                                }
                              />
                              <small>{this.state.sourceError}</small>
                            </div> : null
                        } */}
                        {
                          <Fragment>
                            {/* {
                              type === 'Video' ?
                                <div className='recommend-checkbox'>
                                  <label><input type="checkbox" onChange={this.handlePartial} checked={this.state.partial} />Partial video</label>
                                </div>
                                : null
                            } */}
                            {type === 'Video' &&
                              <div className='fromtoTime form-group d-flex mt-3'>

                                <div style={{ width: '16%' }}>
                                  <label>
                                    From*
                                  </label>
                                  <div className='d-flex'>
                                    <select className='form-control mt-1' value={this.state.from1?.length === 1 ? `0${this.state.from1}` : this.state.from1} onChange={(e) => { this.getFromTime1(e.target.value) }}>
                                      {
                                        times.map(el => {
                                          return (
                                            <option>{el}</option>
                                          )
                                        })
                                      }
                                    </select> &nbsp; &nbsp;&nbsp;
                                    <select className='form-control mt-1' value={this.state.from2?.length === 1 ? `0${this.state.from2}` : this.state.from2} onChange={(e) => { this.getFromTime2(e.target.value) }}>
                                      {
                                        times.map(el => {
                                          return (
                                            <option>{el}</option>
                                          )
                                        })
                                      }
                                    </select>
                                  </div>
                                </div>&nbsp; &nbsp;&nbsp;
                                <div style={{ width: '16%', marginLeft: 20 }}>
                                  <label>
                                    To*
                                  </label>
                                  <div className='d-flex'>
                                    <select className='form-control mt-1' value={this.state.to1?.length === 1 ? `0${this.state.to1}` : this.state.to1} onChange={(e) => { this.getToTime1(e.target.value) }}>
                                      {
                                        times.map(el => {
                                          return (
                                            <option value={el}>{el}</option>
                                          )
                                        })
                                      }
                                    </select> &nbsp;&nbsp; &nbsp;
                                    <select className='form-control mt-1' value={this.state.to2?.length === 1 ? `0${this.state.to2}` : this.state.to2} onChange={(e) => { this.getToTime2(e.target.value) }}>
                                      {
                                        times.map(el => {
                                          return (
                                            <option value={el}>{el}</option>
                                          )
                                        })
                                      }
                                    </select>
                                  </div>
                                </div>
                              </div>
                            }
                            <small>{this.state.toError}</small>
                            {/* {
                              window.location.pathname.split('/')[1] === 'my-content' ?
                                null
                                :
                                <div className='recommend-checkbox'>
                                  <label><input type="checkbox" onChange={this.handleChecked} checked={this.state.recommended} />Recommended</label>
                                </div>
                            } */}
                          </Fragment>
                        }
                        <hr style={{ marginTop: 25 }} />

                        <div className="save-btn mt-2">
                          {
                            edit ?
                              <button style={{ backgroundColor: theme?.bgColor }}
                                disabled={this.props.documentDataState}
                                onClick={() => this.editResource()}
                              >
                                Save
                              </button> :
                              <button style={{ backgroundColor: theme?.bgColor }}
                                disabled={this.props.documentDataState}
                                onClick={() => this.saveVideoOrDocument()}
                              >
                                Save
                              </button>
                          }
                          <button onClick={() => this.backtoBubble()}>Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
        <div className="feeds-details" style={{ display: this.state.isView ? 'block' : 'none', }}>
          {/* <Notespopup
            activeFeedData={this.state.resource}
            saveNote={this.saveNote}
            likeClick={this.likeClick}
            closeNotes={this.closeDetails}
          /> */}
        </div>
      </Fragment >
    );
  }
}

const mapStateToProps = (state) => {
  const { previewData, articleSource, documentData, documentDataState, topicsListOfSubject, editQuestionData, percent, resourceList } = state.manageSkillpath;
  const { theme } = state.account
  const { successMessageText, successMessage, successEnable } = state.error;
  return {
    previewData, articleSource, documentData, documentDataState, topicsListOfSubject, editQuestionData, percent, resourceList, theme,
    successEnable, successMessageText, successMessage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    addLink, googleLinkPreview, handleChangeSource, uploadDocument, uploadVideo, resetPercentage, updateContent, addQuizToPod,
    clearErrors
  }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AddResource));
